import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import type { Category, VaultItem } from './vaultData'

interface Props {
  title: string
  categories: Category[]
  selection: VaultItem[]
  /** The category on screen: adding to it would change nothing. */
  exceptId: string
  onPick: (category: Category) => void
  onClose: () => void
}

/** "Add N files to": the categories OnlyFans accepts media into, with how many are already there. */
export function CategoryMenu({ title, categories, selection, exceptId, onPick, onClose }: Props) {
  const { t } = useTranslation('library')
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose()
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  const options = categories.filter(
    (c) => c.id !== exceptId && selection.some((m) => (m.addableTo.length ? m.addableTo.includes(c.id) : c.canUpdate)),
  )
  return (
    <>
      <div className="lib-backdrop" onClick={onClose} />
      <div className="lib-pop lib-menu" role="menu" aria-label={title}>
        <span className="lib-menu-head">{title}</span>
        {options.map((c) => {
          const have = selection.filter((m) => m.inCategories.includes(c.id)).length
          const all = have === selection.length
          return (
            <button key={c.id} type="button" role="menuitem" className="lib-menu-item" onClick={() => onPick(c)}>
              <span className="lib-menu-label">{c.name}</span>
              <span className={`lib-menu-meta ${all ? 'is-on' : ''}`}>
                {all ? t('alreadyIn') : have ? t('someAlreadyIn', { count: have }) : ''}
              </span>
            </button>
          )
        })}
      </div>
    </>
  )
}
